// extracted by mini-css-extract-plugin
export default {"container":"IconBox_container__zSBu2","message":"IconBox_message__KHBqN","workq_style":"IconBox_workq_style__JE7nr","small_blue":"IconBox_small_blue__KZ41R"};